import { AxiosResponse } from "axios";

import { $axios } from "@/shared/api";
import {
  IDeleteDialogParams,
  IDialog,
  IGetDialogsParams,
  IGetDialogsResponse,
  ISearchDialogsParams,
  ISearchDialogsResponse,
} from "../types";

class DialogsService {
  async getDialog(id: string) {
    const response = await $axios.get<string, AxiosResponse<IDialog>>(
      `/GetAIChatDetails/${id}`
    );
    return response.data;
  }

  async getDialogs({ ai_chat_id, page, limit }: IGetDialogsParams) {
    const searchParams = new URLSearchParams([["ai_chat_id", ai_chat_id]]);

    if (page) searchParams.append("page", String(page));

    if (limit) searchParams.append("limit", String(limit));

    const response = await $axios.get<
      IGetDialogsParams,
      AxiosResponse<IGetDialogsResponse>
    >("/GetDialogs", { params: searchParams });
    return response.data;
  }

  async searchDialogs({
    ai_chat_id,
    query,
    limit,
    page,
  }: ISearchDialogsParams) {
    const searchParams = new URLSearchParams([
      ["ai_chat_id", ai_chat_id],
      ["query", query],
    ]);

    if (page) searchParams.append("page", String(page));

    if (limit) searchParams.append("limit", String(limit));

    const response = await $axios.get<
      ISearchDialogsParams,
      AxiosResponse<ISearchDialogsResponse>
    >("/SearchDialogs", { params: searchParams });
    return response.data;
  }

  async deleteDialog({ dialog_id }: IDeleteDialogParams) {
    await $axios.delete<IDeleteDialogParams, AxiosResponse<void>>(
      `/DeleteDialog/${dialog_id}`
    );
  }
}

export const dialogsService = new DialogsService();
